<template>
  <div v-if="listItems && listItems.count > 0" @wheel="wheelScroll">
    <div v-if="mouseActivated" class="remote-focus">
      <div
        v-show="focusedLine > 0"
        class="arrow-box up"
        @click="onClick('up')"
        @mouseover="mouseFocus = 'U'"
        @mouseleave="mouseFocus = ''"
      >
        <img
          v-if="mouseFocus == 'U'"
          class="arrow"
          src="@/assets/button-remote-control-focuson-up.png"
        />
        <img v-else class="arrow" src="@/assets/button-remote-control-up.png" />
      </div>
      <div
        v-if="focusedLine < maxLine - 3"
        class="arrow-box down"
        @click="onClick('down')"
        @mouseover="mouseFocus = 'D'"
        @mouseleave="mouseFocus = ''"
      >
        <img
          v-if="mouseFocus == 'D'"
          class="arrow"
          src="@/assets/button-remote-control-focuson-down.png"
        />
        <img
          v-else
          class="arrow"
          src="@/assets/button-remote-control-down.png"
        />
      </div>
    </div>
    <div v-else-if="fousedView == 'default'" class="default-focus"></div>
    <div class="list" :style="computedStyleObject">
      <div
        class="detail-vod-card-area"
        v-for="cardData in listItems.list"
        :key="cardData.id"
        ref="card"
      >
        <detail-vod-card
          :cardData="cardData"
          :focuseId="focuseId"
          ref="cardComp"
        ></detail-vod-card>
      </div>
    </div>
  </div>
</template>

<script>
import DetailVodCard from "../card/DetailVodCard.vue";

export default {
  components: {
    DetailVodCard,
  },

  data() {
    return {
      isActiveVue: true,
      styleObject: {
        top: 0,
      },
      focusedLine: 0,
      focuseId: 0,
      scrollPixsel: 0,
      mouseFocus: "",
    };
  },

  props: {
    // listItems : Object,
    // componentStyle : Object,
  },

  computed: {
    listItems() {
      return this.$store.getters.gameVodList;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
    computedStyleObject() {
      return {
        top: this.styleObject.top + "px",
      };
    },
    maxLine() {
      return (this.listItems.count || this.listItems.length) - 1;
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue && val.focusView == "default") {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
        }
      }
    },
    focusedLine(val, oldVal) {
      this.focuseId = this.listItems.list[val].id;
    },
  },

  methods: {
    upKeyProc(keyInput) {
      if (this.focusedLine > 0) {
        this.focusedLine -= 1;
        this.styleObject.top += this.getScrollPixsel();
      }
    },
    downKeyProc(keyInput) {
      if (this.focusedLine < this.maxLine) {
        this.focusedLine += 1;
        this.styleObject.top -= this.getScrollPixsel();
      }
    },
    onClick(direction) {
      switch (direction) {
        case "up":
          this.focusedLine -= 4;
          if (this.focusedLine < 0) {
            this.focusedLine = 0;
          }
          break;
        case "down":
          this.focusedLine += 4;
          if (this.focusedLine > this.maxLine) {
            this.focusedLine = this.maxLine;
          }
          break;
      }
      this.styleObject.top = -(this.focusedLine * this.getScrollPixsel());
    },
    leftKeyProc(keyInput) {
      this.$store.commit("SET_FOCUSED_VIEW", "gnb");
    },
    backKeyProc(keyInput) {
      this.$router.go(-1);
    },
    enterKeyProc(keyInput) {
      this.$children[this.focusedLine].clickCard();
    },
    getScrollPixsel() {
      return this.$refs.card[0].scrollHeight;
    },
    wheelScroll(e) {
      if (this.isActiveVue) {
        if (e.deltaY > 0) {
          this.downKeyProc();
        } else {
          this.upKeyProc();
        }
      }
    },
  },
  created() {
    this.focuseId = this.listItems.list[this.focusedLine].id;
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.list {
  position: relative;
  height: 100%;
  transition-duration: 0.3s;
  padding-left: 40px;
  padding-top: 54px;
}

.default-focus {
  position: absolute;
  width: 1174px;
  height: 222px;
  left: 40px;
  margin-top: 50px;
  /* padding: 10px 10px 8px; */
  border: solid 4px #eeeeee;
  z-index: 5;
}

.no-contents {
  font-size: 32px;
  left: 650px;
  top: 460px;
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.95);
}
.remote-focus {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}

.remote-focus .arrow-box {
  position: absolute;
  height: 64px;
  width: 100%;
  z-index: 10;
  text-align: center;
}

.remote-focus .arrow-box.up {
  top: 0px;
}

.remote-focus .arrow-box.down {
  bottom: 0px;
}

.remote-focus .arrow {
  width: 64px;
  height: 64px;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .list {
    padding-left: 32px;
    padding-top: 32px;
  }

  .default-focus {
    position: absolute;
    width: 942px;
    height: 156px;
    left: 40px;
    margin-top: 29px;
    margin-left: -8px;
    border: solid 3px #eeeeee;
    z-index: 5;
  }
}
</style>
